import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { motion } from 'framer-motion';
import img1 from "../assets/images/admission.jpeg";

const Belong = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className='w-full flex items-center justify-center font-opensans bg-gradient-to-br from-[#ccd6d1] to-[#e0e6e1] min-h-screen' 
      style={{
        backgroundImage: 'linear-gradient(rgba(204, 214, 209, 0.72), rgba(224, 230, 225, 0.15)), url(' + img1 + ')',
        backgroundBlendMode: 'overlay',
        backgroundSize: 'cover'
      }}
    >
      <motion.div 
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className='w-full sm:w-11/12 md:w-8/12 flex flex-col gap-4 sm:gap-5 py-6 sm:py-10 px-4 sm:px-10 items-center justify-center bg-white/70 backdrop-blur-sm rounded-2xl shadow-2xl mt-[-500px] sm:mt-[-300px] mb-[-500px] sm:mb-[-300px]'
      >
        <motion.h2 
          className='text-[#0e4d38] text-center font-bold text-2xl sm:text-3xl md:text-[42px] uppercase tracking-wide'
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          Where All Belong
        </motion.h2>
        
        <motion.div 
          className='w-[15%] mx-auto h-[2px] sm:h-[3px] bg-[#23376c] mt-[-6px] sm:mt-[-10px]'
          initial={{ width: 0 }}
          animate={{ width: '15%' }}
          transition={{ duration: 1 }}
        ></motion.div>

        <p className='text-center text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed px-2 sm:px-0'>
          We believe education is a transformative journey enriched by the unique perspectives and experiences each student brings. Our commitment to diversity, equity, and inclusion (DE&I) is not just a statement—it's our core philosophy.
        </p>

        <motion.button 
          className='bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-300 px-6 sm:px-8 py-2 sm:py-3 text-black rounded-full font-semibold transition-all duration-200 hover:bg-[#fa6f00] hover:text-white text-sm sm:text-base'
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Link
            to="https://admission.maya.edu.in/"
            onClick={() => {
              window.scrollTo(0, 0);
              // handleLinkClick(); // Uncomment if this function is defined
            }}
            className="font-semibold text-black transition-all duration-200 hover:text-yellow-600"
          >
            {isHovered ? '🌈 Embrace Your Journey' : 'Apply Now'}
          </Link>
        </motion.button>

        {/* Creative Diversity Representation */}
        {/* <div className='flex space-x-4 mt-4 sm:mt-5 opacity-70'>
          <span className='text-xl sm:text-2xl'>🌍</span>
          <span className='text-xl sm:text-2xl'>🤝</span>
          <span className='text-xl sm:text-2xl'>💡</span>
          <span className='text-xl sm:text-2xl'>🌈</span>
        </div> */}
      </motion.div>
    </div>
  )
}

export default Belong